import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JsonControl from '../JsonControl';
import RelationshipsGraphDialog from './RelationshipsGraphDialog';
import RelationshipsTable from './RelationshipsTable';

class Relationship extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        
        this.state = {
            expanded: false
        }

        this.biDirectionalTypes = ['Partner-of', 'Co-Investor-with', 'Competitor-with', 'Relative-of', 'Sibling-Of', 'Spouse/Partner-Of'];
    }

    toggle() {
        this.setState({
            expanded: this.state.expanded ? false : true
        })
    }

    render() {

        var that = this;
        var toggleClasses = 'fa group-toggle'
        if (this.state.expanded) {
            toggleClasses += ' fa-chevron-down';
        } else {
            toggleClasses += ' fa-chevron-right';
        }

        
        // Extract the subject info
        var subject = this.props.relationship.subject.anchor || 'Unknown subject';
        if ('label' in this.props.relationship.subject) {
            subject = this.props.relationship.subject.label;
        }

        // Extract the relation info
        let bi = false;
        var relation = 'Unknown relation';
        if ('type' in this.props.relationship.predicate) {
            relation = this.props.relationship.predicate.type;
            if ('properties' in this.props.relationship.predicate && relation in this.props.relationship.predicate.properties) {
                relation = this.props.relationship.predicate.properties[relation];
            }
            if (this.biDirectionalTypes.includes(relation)) {
                bi = true;
            }
        }

        // Extract the object info
        var object = this.props.relationship.object.anchor || 'Unknown object';
        if ('label' in this.props.relationship.object) {
            object = this.props.relationship.object.label;
        }

        return(
            <div>
            {(this.props.relationship) &&
                <div>
                    <h2 className="group-title" onClick={ this.toggle }>
                        {subject}
                        <span className={`fa ${bi ? 'fa-arrows-h' : 'fa-long-arrow-right'}`} style={{marginLeft: '3px', marginRight: '3px'}}></span>
                        {relation}
                        <span className={`fa ${bi ? 'fa-arrows-h' : 'fa-long-arrow-right'}`} style={{marginLeft: '3px', marginRight: '3px'}}></span>
                        {object}
                        <span className={toggleClasses}/>
                    </h2>

                    <div className={ this.state.expanded ? 'group-body indent-body expanded' : 'group-body indent-body' }>
                    {
                        <JsonControl results={this.props.relationship}/>
                    }
                    </div>
                </div>
            }
            </div>
        );
    }
};

Relationship.propTypes = {
    relationship: PropTypes.object
};

class Relationships extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        
        this.state = {
            expanded: false,
            enLangauge: true
        }
    }

    componentWillMount() {
        // Check if selected language is not English (in which case we don't show key phrases)
        var code = localStorage.getItem('languageCode');
        if (code && code !== 'en') {
            this.state = {
                enLangauge: false
            }
        }
    }

    toggle() {
        this.setState({
            expanded: this.state.expanded ? false : true
        })
    }

    render() {

        var that = this;
        var toggleClasses = 'fa group-toggle'
        if (this.state.expanded) {
            toggleClasses += ' fa-chevron-down';
        } else {
            toggleClasses += ' fa-chevron-right';
        }

        return(
            <div>
            {(this.props.relationships && this.props.relationships.length > 0 && this.state.enLangauge) &&
                <div>
                    <h2 className="group-title" style={{verticalAlign:'middle'}}>
                        <span className='results-count' onClick={ this.toggle }>
                            <span className={toggleClasses}/>
                            relationships ({this.props.relationships.length})
                        </span>
                        <span style={{marginLeft:'15px'}}>
                            <RelationshipsTable json={this.props.json} relationships={this.props.relationships} iconOnly={true}/>
                        </span>
                        <span style={{marginLeft:'15px'}}>
                            <RelationshipsGraphDialog 
                                entitiesData={this.props.entitiesData}
                                relationships={this.props.relationships} 
                                iconOnly={true}/>
                        </span>
                        
                    </h2>

                    <div className={ this.state.expanded ? 'group-body expanded' : 'group-body' }>
                    {
                        this.props.relationships.map(function(relationship, idx) {
                            return <Relationship key={idx} relationship={relationship}/>
                        })                      
                    }
                    </div>
                </div>
            }
            </div>
        );
    }
};

Relationships.propTypes = {
    relationships: PropTypes.array
};

export default Relationships;

